import React from 'react';
import moment from 'moment';
import { useGlobalState } from '../../../state';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const [{ user }] = useGlobalState();
    // Same rule as desktop: staff can only change payments created today
    const canModify = !(user.role === "STAFF" && !moment(data.createTime).isSame(moment(), "date"));

    const rows = [
        { label: 'Date', value: moment(data.paymentDate).format("DD-MM-YYYY"), inHeader: true, hideLabel: true },
        { label: 'Amount', value: data.amount.toLocaleString(user.locales, { style: "currency", currency: user.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }), bold: true },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.labourName}
            id={data.id}
            rows={rows}
            menuItems={canModify ? menuItems : undefined}
        />
    );
};

export default Mobile;
